// Outside the App function
import { useLocation } from "react-router-dom";
import UnityContainer from "pages/unity";
import UnityMenu from "pages/UnityMenu/UnityMenu";

const UnityRouteHandler = () => {
  const location = useLocation();

  if (window.vuplex) {
    return <UnityContainer />;
  }
  return <UnityMenu />;
};

export default UnityRouteHandler;